var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{style:(_vm.style)},[_c('v-flex',{staticClass:"text-xs-center",staticStyle:{"padding-bottom":"700px"},attrs:{"xs12":""}},[_c('v-progress-circular',{attrs:{"size":50,"width":3,"color":"amber","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }